import { DropDownProps } from 'antd';

export enum AccountMenuKeys {
  logout = 'logout',
  settings = 'settings',
}

export type DropdownButtonProps = { overlay: DropDownProps['overlay']; email: string | null };
export type DropdownMenuProps = { logout: () => void };
